module.exports = __webpack_public_path__ + "static/img/no-message.aaff2d9d.png";